import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const CartContainer = styled.article`
    padding: 65px 0;
`;

export const Title = styled.h2`
    ${FONTS.H2};
    color: ${COLORS.white};
    margin-bottom: 33px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H3};
    }
`;

export const ContentContainer = styled.section`
    display: flex;
    gap: 32px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        flex-direction: column;
        gap: 12px;
    }
`;

export const ShopListContainer = styled.div`
    max-width: 592px;
    padding: 31px 37px 46px 37px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: rgba(255, 255, 255, .05);
`;

export const TitleWrap = styled.div`
    flex-direction: column;
    gap: 33px;
`;

export const TitleList = styled.h3`
    width: 100%;
    ${FONTS.H3};
    color: ${COLORS.white};
`;

export const ShopListContent = styled.div`
    width: 100%;
    gap: 16px;
`;

export const ShopList = styled.div`
    width: 100%;
    gap: 16px;
`;
